import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"; // 引入 Vuex store
import Vuex from "vuex";
Vue.use(Vuex);

import service from "./utils/service"; //全局工具-网络请求
Vue.prototype.$service = service;

import "@/utils/rem.js";

// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: "WEA8fSoAK2rcx18sLgjeNp6lDSlaODyq"
})

import uWeb from '@/utils/uni.webview.js'
Vue.prototype.$uWeb = uWeb

// 引入ElementUI插件
import ElementUI from "element-ui";
// 引入样式
import "element-ui/lib/theme-chalk/index.css";
// 使用插件
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
